import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import Profile from '../components/Profile';
import '../css/style.css';
import '../components/Home.css';

class ProfileLayout extends Component {

    render(){
        return (
            <SimpleLayout>
                <Profile />
            </SimpleLayout>              
        );
    }

}
export default ProfileLayout;